"use strict";

export var TreeListConstants = {
  TREE_VIEW_SET_STORE: 'TREE_VIEW_SET_STORE',
  TREE_VIEW_DESTROY_STORE: 'TREE_VIEW_DESTROY_STORE',
  TREE_VIEW_UPDATE_UUID: 'TREE_VIEW_UPDATE_UUID',
  TREE_VIEW_FORM_INIT_TABLE: 'TREE_VIEW_FORM_INIT_TABLE',
  TREE_VIEW_FORM_DESTROY_TABLE: 'TREE_VIEW_FORM_DESTROY_TABLE',
  TREE_VIEW_FORM_INIT: 'TREE_VIEW_FORM_INIT',
  TREE_VIEW_FORM_REFRESH: 'TREE_VIEW_FORM_REFRESH',
  TREE_VIEW_DELETE_ROWS: 'TREE_VIEW_DELETE_ROWS',
  TREE_VIEW_FORM_UPDATE: 'TREE_VIEW_FORM_UPDATE'
};